module.exports = __webpack_public_path__ + "img/support-line.1f760ed.svg";